import { render } from "./TestPage.vue?vue&type=template&id=5ad24801&ts=true"
import script from "./TestPage.vue?vue&type=script&lang=ts"
export * from "./TestPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__